import axios from '../../commons/http/axios';
import { PORTAL_SERVICOS_BACKEND, PORTAL_SERVICOS_OAUTH } from '../constants/environment';

export default {
	cadastro: req => {
		return axios.post(`${PORTAL_SERVICOS_BACKEND}/usuario/cadastro`, req).then(res => {
			return res.data;
		});
	},
	get: () => {
		return axios.get(`${PORTAL_SERVICOS_BACKEND}/usuario`).then(res => {
			return res.data;
		});
	},
	getNomeCdUsuario: () => {
		return axios.get(`${PORTAL_SERVICOS_BACKEND}/usuario/cd`).then(res => {
			return res.data;
		});
	},
	edit: req => {
		return axios.post(`${PORTAL_SERVICOS_BACKEND}/usuario/editar`, req).then(res => {
			return res.data;
		});
	},
	login: req => {
		let token = '';
		if (req.access_token) {
			token = `?access_token=${req.access_token}`;
		}
		return axios.post(`${PORTAL_SERVICOS_BACKEND}/login${token}`, req).then(res => {
			return res.data;
		});
	},
	logout: () => {
		return axios.get(`${PORTAL_SERVICOS_OAUTH}/oauth/uri-logout-govbr`).then(res => {
			return res.data;
		});
	},
	recuperarSenha: req => {
		return axios.post(`${PORTAL_SERVICOS_BACKEND}/usuario/recuperar-senha`, req).then(res => {
			return res.data;
		});
	},
	redefinirSenha: (token, body) => {
		return axios
			.post(`${PORTAL_SERVICOS_BACKEND}/usuario/redefinir-senha/${token}`, body)
			.then(res => {
				return res.data;
			});
	},
	alterarSenha: req => {
		return axios.post(`${PORTAL_SERVICOS_BACKEND}/usuario/alterar-senha`, req).then(res => {
			return res.data;
		});
	},
	getUsersLinkedByCPNJ: async ({ cnpj, page }) => {
		const res = await axios.get(
			`${PORTAL_SERVICOS_BACKEND}/funcionarios?cnpj=${cnpj}&page=${page}`
		);
		return res.data;
	},
	delUser: async body => {
		const res = await axios.delete(`${PORTAL_SERVICOS_BACKEND}/funcionarios/delete`, {
			data: body
		});
		return res.data;
	},
	searchCpf: async cpf => {
		const res = await axios.get(`${PORTAL_SERVICOS_BACKEND}/funcionarios/consultar/?cpf=${cpf}`);
		return res.data;
	},
	registerUser: async body => {
		const res = await axios.post(`${PORTAL_SERVICOS_BACKEND}/funcionarios/cadastrar`, body);
		return res.data;
	},
	getUsers: async ({ cpfCnpj, nome, tipoPerfil, page }) => {
		let url = `${PORTAL_SERVICOS_BACKEND}/usuario/consultar?`;
		if (cpfCnpj !== undefined) {
			url = url + `cpfCnpj=${cpfCnpj}&`;
		}
		if (nome !== undefined) {
			url = url + `nome=${nome}&`;
		}
		if (tipoPerfil !== undefined) {
			url = url + `tipoPerfil=${tipoPerfil}&`;
		}
		if (page !== undefined) {
			url = url + `page=${page}`;
		}
		const res = await axios.get(url);
		return res.data;
	},
	editarPerfilUsuario: req => {
		return axios.put(`${PORTAL_SERVICOS_BACKEND}/usuario/perfil/editar`, req).then(res => {
			return res.data;
		});
	}
};
